import { Directive, ElementRef, Input } from '@angular/core';

import { Theme } from 'src/app/configs/theme.config';
import { Colors, DashboardModes, Desktop } from '../../api/models';
import { AppStateService } from '../../services/app-state.service';
import { CancelBtnType } from '../../types/app-cancel-btn.type';
import { ThemeColorType } from '../../types/theme-color-type.type';
import { ThemeColorService } from './theme-color.service';

@Directive({
  selector: '[themeColor]',
  standalone: true,
})
export class ThemeColorDirective {
  @Input() themeColor: ThemeColorType;
  @Input('isAllowSetTheme') isAllow?: boolean = true;
  @Input() statsWidgetNumber?: number;

  appTheme: Desktop;
  cancelBtnType: CancelBtnType = Theme.cancelBtnType;
  primaryColor: Colors;
  secondaryColor: Colors;
  backgroundImagePath: string;
  dashboardMode: DashboardModes;

  constructor(
    private element: ElementRef<HTMLElement>,
    protected themeColorService: ThemeColorService
  ) {}

  ngOnInit(): void {
    this.appTheme = AppStateService.appTheme;
    this.secondaryColor = AppStateService.secondaryColor;
    this.primaryColor = AppStateService.primaryColor;
    this.backgroundImagePath = AppStateService.backgroundImagePath;
    this.dashboardMode = AppStateService.dashboardMode;
    if (this.isAllow) this.setClass();
  }

  setClass() {
    let className = '';

    switch (this.themeColor) {
      case 'text':
        className = this.themeColorService.getTextColor();
        break;

      case 'btn':
        className = this.themeColorService.getBtnColor();
        break;

      case 'btn-light':
        className = this.themeColorService.getBtnLightColor();
        break;

      case 'btn-info':
        className = this.themeColorService.getBtnInfoColor();
        break;

      case 'btn-light-info':
        className = this.themeColorService.getBtnLightInfoColor();
        break;

      case 'btn-gradient':
        className = this.themeColorService.getBtnGradientColor();
        break;

      case 'cancel-btn':
        className = this.themeColorService.getCancelBtnColor();
        break;

      case 'ring-btn-gradient':
        className = this.themeColorService.getRingBtnGradientColor();
        break;

      case 'bg-image':
        if (this.backgroundImagePath) {
          this.element.nativeElement.style.backgroundImage =
            'url(' + this.backgroundImagePath + ')';
          return '';
        }

        className = this.themeColorService.getBgImage();
        break;

      case 'stats-widget-bg-color':
        className = this.themeColorService.getStatsWidgetBgColor(
          this.statsWidgetNumber
        );
        break;

      case 'loading-bar':
        className = this.themeColorService.getLoadingBarColor();
        break;

      case 'timer-loading':
        className = this.themeColorService.getTimerLoadingColor();
        break;
    }

    this.element.nativeElement.className =
      this.element.nativeElement.className + ' ' + className;
  }
}
